import React from "react";
import Chart from "react-apexcharts";

const TotalEmployeesChart = ({ 
  totalEmployees = 0, 
  activeEmployees = 550, 
  terminatedEmployees = 5 ,
  resignedEmployees = 5,
  data= []
}) => {
  const names = data.map(item => item.name);
  const counts = data.map(item => item.count);
  
  // Calculate total for percentage
  const total = counts.reduce((sum, count) => sum + count, 0);
  
  // Generate colors - using a standard color palette
  const defaultColors = ["#006400","#ffb500","#2E7D32", "#1976D2", "#FFA000", "#D32F2F"];
  const colors = data.map((_, index) => defaultColors[index % defaultColors.length]);

  const options = {
    chart: {
      type: 'bar',
      stacked: true,
      stackType: '100%',
      toolbar: {
        show: false
      }
    },
    // grid: { padding: { left: 0, right: 0, top: 0, bottom: 0 } },

    plotOptions: {
      bar: {
         columnWidth: "100%",
        horizontal: true,
        barHeight: '50%',
        distributed: false,
        // distributed: true,
        // borderRadius: 4, 
      },
    },
    dataLabels: {
      enabled: true,
    //   formatter: function (val, opt) {
    //     const index = opt.dataPointIndex;
    //     const count = counts[index];
    //     return count;
    //   },
      style: {
        colors: ['#fff'],
        fontWeight: 600
      }
    },
    xaxis: {
      categories: [''],
      labels: {
        show: false
      },
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      }
    },
    yaxis: {
      labels: {
        show: false
      }
    },
    tooltip: {
      enabled: true
    },
    legend: {
      show: false
    },
    grid: {
      show: false,
      padding: { left: 0, right: 0, top: 0, bottom: 0 } 
    },
    colors: colors
  };

  const series = names.map((name, index) => ({
    name: name,
    data: [counts[index]]
  }));
  // const options = {
  //   chart: {
  //     type: "donut",
  //     background: "transparent",
  //   },
  //   plotOptions: {
  //     pie: {
  //       startAngle: -90,
  //       endAngle: 90,
  //       offsetY: 10,
  //       donut: {
  //         size: '70%',
  //         labels: {
  //           show: true,
  //           name: {
  //             show: true,
  //             fontSize: '14px',
  //             color: '#000 !important',
  //             offsetY: -10,
  //           },
  //           value: {
  //             show: true,
  //             fontSize: '12px',
  //             fontWeight: 600,
  //             offsetY: -50,
  //             color: '#000 !important',
  //             formatter: (val) => val.toLocaleString()
  //           },
  //           total: {
  //             show: true,
  //             label: 'Total Employees',
  //             fontSize: '12px',
  //             color: '#000 !important',
  //             // fontWeight: 600,
  //             formatter: () => totalEmployees.toLocaleString()
  //           }
  //         }
  //       }
  //     }
  //   },
  //   dataLabels: {
  //     enabled: false
  //   },
  //   stroke: { show: false },
  //   fill: {
  //     type: "solid",
  //   },
  //   legend: {
  //     show: false,
  //   },
  //   colors: ["#D3001A","#ffb500",  ],
  //   labels: ["Active Workforce", "Terminated Employees"],
  //   responsive: [{
  //     breakpoint: 480,
  //     options: {
  //       chart: {
  //         height: 280
  //       },
  //       legend: {
  //         position: 'center'
  //       }
  //     }
  //   }],
  //   tooltip: {
  //     enabled: false
  //   }
  // };

  // const series = [activeEmployees, terminatedEmployees];

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        // alignItems: "center",
        justifyContent: "top",
        padding: "35px",
        paddingLeft: "10px",
        paddingRight: "10px",
        paddingTop: "10px",
        width: "100%", 
        // height: "350px",
        margin: "auto",
      }}
    >
      <div className="statistic-header">
      <h5 style={{ color: "#555" }}>Employee Statistics</h5>
     
      
      </div>
      {/* <div style={{ color: "#555" }} className="d-flex justify-content-between mt-2">
        <div className="d-flex align-items-center ">
          <i className="fa fa-user-circle me-1"  ></i>
          <div className="d-flex flex-column">
          <span className="small fw-bold">Total Employees</span>
          <span className="small ">Includes employees who are not settled</span>
          </div>
          
        </div>
        <div className="d-flex align-items-center ">
          <span className="small fw-bold">{activeEmployees}</span>
        </div>
        
      </div> */}
      <div style={{ color: "#555" }} className="d-flex justify-content-between mt-2">
        <div className="d-flex align-items-center ">
          <i className="fa fa-user-circle me-1"  ></i>
          <span className="small fw-bold">Total Active Workforce</span>
        </div>
        <div className="d-flex align-items-center ">
          <span className="small fw-bold">{totalEmployees}</span>
        </div>
        
      </div>

      <div style={{ color: "#555" }} className="d-flex   justify-content-between mt-2">
      <div className="d-flex align-items-center ">
          <i className="fa fa-user-times me-1"  ></i>
          <div className="d-flex flex-column">
          <span className="small fw-bold">Employees on Notice Period</span>
          {/* <span className="small ">Includes employees who are not settled</span> */}
          </div>
          
        </div>
        <div className="d-flex align-items-center ">
          <span className="small fw-bold">{resignedEmployees}</span>
        </div>
      </div>
      {/* <div className="statistic-header"> */}
      <span  className="small fw-bold mt-2">Employee Status</span>
     
      {/* </div> */}
      {/* <Chart options={options} series={series} type="donut" height={250} /> */}
      <div className=""
       style={{ marginTop: "-30px", marginLeft: "-14px", color: "#555" }} 
       >
      <Chart
        options={options}
        series={series}
        type="bar"
        height={100}
      />
      </div>
      <div className="d-flex" style={{ marginTop: "-30px" }}>
      <table className="table table-bordered" style={{ tableLayout: "fixed", width: "100%" }}>
        <tbody>
          <tr>
            {data.map((item, index) => (
              <td
                key={index}
                className="text-center align-middle"
                style={{
                  width: "120px",  
                  height: "100px", 
                  verticalAlign: "middle",
                }}
              >
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <span className="small fw-bold">{item.count}</span>
                  <span className="small">{item.name}</span>
                </div>
              </td>
            ))}
          </tr>
        </tbody>
      </table>
      </div>
      
    </div>
  );
};

export default TotalEmployeesChart;
